import type {
  FieldBorderOperator,
} from '../types'

// Constants
import { MODEL } from 'fc-model-fieldborder'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: FieldBorderOperator = composeOperator({
  model: MODEL,
  branch: 'uploadOperations',
})

export default operator
